module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      William Shakespeare\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("William Shakespeare was an English poet, playwright, and actor. He is widely regarded as the greatest dramatist in the English language. Shakespeare is often called England’s national poet and the “Bard of Avon.”"), _c('BR'), _vm._v("  ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/q2b0PU/tc-custom/9781504062978.jpg?1696813820088",
      "alt": "This image is the cover for the book Julius Caesar"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Julius Caesar\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Shakespeare’s tragic tale of power, politics, friendship, and betrayal in ancient Rome.")])]), _c('p', [_vm._v("Julius Caesar is basking in the glow of military triumph—but his friend Brutus has fallen in with a band of conspirators who argue that Caesar’s ambitions may soon cast a pall of tyranny over Rome’s people. Torn, Brutus finally agrees to pick up a knife and join in assassinating Caesar on the Ides of March.")]), _vm._v(" His act is driven by a fear of dictatorship and a desire to protect the citizenry, but the events that follow will have heart-wrenching consequences, in one of the immortal playwright William Shakepeare’s greatest works.\n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0